import React, { Component } from 'react'
import Button from '@mui/material/Button'
import { Box } from '@mui/material'
import LoginRoundedIcon from '@mui/icons-material/LoginRounded'

import '../logout/LogoutPageStyles.css'
import './404Page.css'

const REDIRECT_SECONDS = 10

class Page404 extends Component {

    constructor(props) {
        super(props)

        // Index de la entidad de la sesion. Si no hay sesion (logout/expiro),
        // entidad_tag no existe y se cae al inicio generico ("/").
        const tag = localStorage.getItem('entidad_tag')
        this.target = (tag && tag !== 'null' && tag !== 'undefined')
            ? '/entidad/' + tag
            : '/'

        this.state = {
            secondsLeft: REDIRECT_SECONDS,
            autoRedirect: true,
        }
    }

    componentDidMount() {
        this.timer = setInterval(this.tick, 1000)
    }

    componentWillUnmount() {
        if (this.timer) clearInterval(this.timer)
    }

    tick = () => {
        if (!this.state.autoRedirect) return
        this.setState(prev => {
            const next = prev.secondsLeft - 1
            if (next <= 0) {
                this.goIndex()
                return { secondsLeft: 0 }
            }
            return { secondsLeft: next }
        })
    }

    cancelRedirect = () => {
        if (this.timer) clearInterval(this.timer)
        this.setState({ autoRedirect: false })
    }

    goIndex = () => {
        if (this.timer) clearInterval(this.timer)
        window.location.href = this.target
    }

    render() {
        const { secondsLeft, autoRedirect } = this.state
        const año = new Date().getFullYear()
        const progress = ((REDIRECT_SECONDS - secondsLeft) / REDIRECT_SECONDS) * 100

        return (
            <div
                className="logout-container"
                style={{ backgroundImage: 'url("/Pegasus0.png")' }}
            >
                <div className="logout-content">
                    <Box className="logout-card">
                        <div className="error-circle" aria-hidden="true">
                            <svg className="error-cross" viewBox="0 0 52 52">
                                <circle cx="26" cy="26" r="24" fill="none" />
                                <path d="M18 18 L34 34 M34 18 L18 34" fill="none" />
                            </svg>
                        </div>

                        <div className="logout-text">
                            <h1>Error 404</h1>
                            <p>Página no encontrada</p>
                        </div>

                        <div className="logout-brand">
                            <img alt="logo" src="/logo_main.png" />
                        </div>

                        {autoRedirect && (
                            <div className="logout-countdown" aria-live="polite">
                                <div className="logout-countdown-bar">
                                    <div
                                        className="logout-countdown-fill error-countdown-fill"
                                        style={{ width: `${progress}%` }}
                                    />
                                </div>
                                <span>Redirigiendo en {secondsLeft}s…</span>
                            </div>
                        )}

                        <div className="logout-actions">
                            <Button
                                onClick={this.goIndex}
                                startIcon={<LoginRoundedIcon />}
                                disableElevation
                                fullWidth
                                sx={{
                                    background:
                                        'linear-gradient(135deg, var(--clr) 0%, var(--clr-hover) 100%) !important',
                                    color: '#fff !important',
                                    textTransform: 'uppercase',
                                    fontWeight: 700,
                                    letterSpacing: '0.06em',
                                    fontSize: '0.95rem',
                                    py: '0.85rem',
                                    borderRadius: '14px',
                                    boxShadow: '0 8px 20px rgba(106, 158, 44, 0.35)',
                                    transition:
                                        'transform 200ms ease, box-shadow 200ms ease, filter 200ms ease',
                                    '&:hover': {
                                        filter: 'brightness(1.05)',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 12px 24px rgba(106, 158, 44, 0.45)',
                                    },
                                }}
                            >
                                Ir ahora
                            </Button>

                            {autoRedirect && (
                                <button
                                    type="button"
                                    className="btn-logout-secondary"
                                    onClick={this.cancelRedirect}
                                >
                                    Cancelar redirección automática
                                </button>
                            )}
                        </div>
                    </Box>
                </div>

                <div className="logout-footer">
                    <span>© {año} Selfia. All rights reserved.</span>
                </div>
            </div>
        )
    }

}

export default Page404
